"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "16", height: "16", viewBox: "0 0 16 16", className: "Icon link-icon", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M7.405 8.57c-1.047-.961-1.032-2.384.001-3.333l3.03-3.069c1.122-1.29 2.878-1.579 3.947-.495 1.04 1.054.688 2.707-.613 3.835l-2.203 2.13a.5.5 0 0 0 .695.72l2.183-2.113c1.67-1.447 2.16-3.745.65-5.275-1.527-1.546-3.944-1.15-5.392.519l-2.99 3.028c-1.444 1.326-1.466 3.43.017 4.79a.5.5 0 1 0 .675-.738zm1.19-1.139c1.047.961 1.032 2.383-.001 3.333l-3.03 3.069c-1.122 1.29-2.878 1.578-3.947.495-1.04-1.054-.688-2.707.613-3.835l2.203-2.13a.5.5 0 0 0-.695-.72L1.555 9.756c-1.67 1.448-2.16 3.745-.65 5.276 1.527 1.546 3.944 1.149 5.392-.52l2.99-3.028c1.444-1.326 1.466-3.429-.017-4.789a.5.5 0 1 0-.675.737z", fill: "#6E6E71", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/link-icon.js
// module id = 1811
// module chunks = 0